import { AuthHeader } from "config/axios"
import makeRequest, { makeRequestWithHeaders, makeRequestWithHeadersForXhr } from "./makeRequest"


const { REACT_APP_MSAL_EXTENSION_ID, REACT_APP_API_URL, REACT_APP_MSAL_TENANT_ID, REACT_APP_MSAL_CLIENT_ID, REACT_APP_MSAL_SECRET_VALUE } = process.env
export const getUserData = async ({ accessToken, userId }) => {
    const url = `https://graph.microsoft.com/v1.0/users/${userId}?$select=extension_${REACT_APP_MSAL_EXTENSION_ID}_BillToAccount,extension_${REACT_APP_MSAL_EXTENSION_ID}_FirstName,extension_${REACT_APP_MSAL_EXTENSION_ID}_LastName,extension_${REACT_APP_MSAL_EXTENSION_ID}_LegalCompanyName,extension_${REACT_APP_MSAL_EXTENSION_ID}_PhoneNumber,id,displayName,mail,preferredLanguage,surname,givenName,businessPhones`
    const headers = {
        Authorization: `Bearer ${accessToken}`
    }
    return await makeRequestWithHeaders(url, 'GET', headers)
}

export const updateUserDataXhr = async ({ userId, payload }) => {
    try {
        const accessTokenRes = await makeRequestWithHeaders(`${REACT_APP_API_URL}/GetAdminAccessToken`, "POST", AuthHeader());

        if (accessTokenRes?.access_token?.length > 0) {
            const url = `https://graph.microsoft.com/v1.0/users/${userId}`;
            const headers = {
                Authorization: `Bearer ${accessTokenRes?.access_token}`,
                'Content-Type': "application/json"
            }
            return await makeRequestWithHeaders(url, "PATCH", headers, null, payload);
        }
    } catch (error) {
        console.log(error);
    } finally {
        return;
    }

}

export const validateBillToAccount = async ({ billToAccount, invoiceNo, contractNo }) => {
    let queryParams = {
        accountNumber: billToAccount
    }
    if (invoiceNo) {
        queryParams.invoiceNumber = invoiceNo;
    } else {
        queryParams.contractNumber = contractNo
    }
    return await makeRequestWithHeaders(`${REACT_APP_API_URL}/ValidateOMSAccount`, "GET", AuthHeader(), queryParams)
}

export const registerToApey = async (payload) => {
    return await makeRequestWithHeaders(`${REACT_APP_API_URL}/AddApayUserAccount`, "POST", AuthHeader(), null, payload);
}